export * from "./presenter";
export * from "./breadcrumb";
export * from "./forms";
export * from "./page-not-found";
export * from './login-failed';
export * from "./filter";
export * from "./list";
export * from "./tree";
export * from "./dropdown";
export * from "./carousel";
export * from "./button";
export * from "./unity";

import { NavigationComponents } from './navigation';
import { BreadcrumbComponents, BreadcrumbServices } from './breadcrumb';
import { FormComponents } from './forms';
import { FilterComponents  } from './filter';
import { PageNotFoundComponent } from './page-not-found';
import { LoginFailedComponent } from './login-failed';
import { PresenterComponent } from './presenter';
import { ListComponents } from './list';
import { TreeItemComponent } from './tree';  
import { DropdownComponent } from './dropdown';
import { CarouselComponents } from './carousel';
import { ButtonComponents } from './button';
import { CardComponents } from './card';
import { UnityComponents } from "./unity";

export const SharedComponents = [
    ...NavigationComponents,
    ...FilterComponents,
    ...BreadcrumbComponents,
    ...FormComponents,
    ...ListComponents,
    ...CarouselComponents,
    ...ButtonComponents,
    ...CardComponents,
    ...UnityComponents,
    PageNotFoundComponent,
    LoginFailedComponent,
    PresenterComponent,
    TreeItemComponent,
    DropdownComponent
];

export const SharedComponentServices = [...BreadcrumbServices];
